module.exports = __webpack_public_path__ + "media/img/home/clients-map/bridebook-b4eebe52551d822f004066c443b6826c.svg";